(() => {
  const DESKTOP_MIN = 992;
  const OPEN_DELAY  = 0;
  const CLOSE_DELAY = 200;

  const isDesktop = () => window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).matches;

  const getHeaderDetails = () =>
    Array.from(document.querySelectorAll('.header .header__nav-list > li.nav-item > header-menu-trigger > details'));

  const closeAllExcept = (keep) => {
    getHeaderDetails().forEach(d => {
      if (d !== keep) d.removeAttribute('open');
    });
  };

  const setAriaExpanded = (details, value) => {
    details.setAttribute('aria-expanded', value ? 'true' : 'false');
  };

  const attach = () => {
    if (!isDesktop()) return;

    const detailsList = getHeaderDetails();
    if (!detailsList.length) return;

    detailsList.forEach(details => {
      if (details.dataset.azHoverBound === '1') return;
      details.dataset.azHoverBound = '1';

      let openT;
      let closeT;

      const trigger = details;
      const panel   = details.querySelector('[details-dropdown]');

      // ── helpers ──────────────────────────────────────────────────────────
      const clearTimers = () => {
        clearTimeout(openT);
        clearTimeout(closeT);
        openT = closeT = null;
      };

      const openNow = () => {
        clearTimers();
        openT = setTimeout(() => {
          closeAllExcept(details);
          details.setAttribute('open', '');
          setAriaExpanded(details, true);
        }, OPEN_DELAY);
      };

      const closeLater = () => {
        clearTimers();
        closeT = setTimeout(() => {
          details.removeAttribute('open');
          setAriaExpanded(details, false);
        }, CLOSE_DELAY);
      };

      /**
       * Returns true if the pointer is leaving toward a related target
       * that is still within the trigger or panel — meaning we should
       * NOT start a close timer.
       */
      const isLeavingToSelf = (e) => {
        const to = e.relatedTarget;
        if (!to) return false;
        return trigger.contains(to) || (panel && panel.contains(to));
      };

      // ── trigger listeners ─────────────────────────────────────────────────
      trigger.addEventListener('pointerenter', openNow);

      trigger.addEventListener('pointerleave', (e) => {
        if (isLeavingToSelf(e)) return; // moving into the panel — stay open
        closeLater();
      });

      // ── panel listeners ───────────────────────────────────────────────────
      if (panel) {
        panel.addEventListener('pointerenter', () => {
          clearTimers();
          details.setAttribute('open', '');
          setAriaExpanded(details, true);
        });

        panel.addEventListener('pointerleave', (e) => {
          if (isLeavingToSelf(e)) return; // moving back to trigger — stay open
          closeLater();
        });
      }

      // ── keyboard ──────────────────────────────────────────────────────────
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          clearTimers();
          details.removeAttribute('open');
          setAriaExpanded(details, false);
          details.querySelector('summary')?.focus?.();
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', attach);
  document.addEventListener('shopify:section:load', attach);

  window.addEventListener('resize', () => {
    if (!isDesktop()) {
      getHeaderDetails().forEach(d => d.removeAttribute('open'));
    }
  });
})();